var map = {
	"./logo_banco_votorantim.png": 70,
	"./logo_cba.png": 71,
	"./logo_cimentos.png": 72,
	"./logo_energia.png": 73,
	"./logo_nexa.png": 74,
	"./logo_votorantim.png": 75
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 241;